<style type="text/css">
  .ws-field-item {
    margin-bottom:  5px!important;
    padding-left: 10px;
  }
  .ws-field-item .ws-field-item-label {
    background-color: #f1f1f1;
  }
  .ws-field-item .el-form-item__content .el-select {
    width:  100%;
  }
  
  .ws-field-item .el-form-item__content .el-cascader {
    width:  100%;
  }
</style>
<template>
  <el-col :span="colspan" ref="rowcol">
    <div class="ws-field-item el-form-item">
      <label class="ws-field-item-label el-form-item__label" v-bind:style="labelStyle" v-text="label"></label>
      <div class="el-form-item__content" v-bind:style="inputStyle">
        <slot></slot>
      </div>
    </div>
  </el-col>
</template>
<script>
  import emitter from './input/emitter';
  export default {
    name: 'field',
    componentName: 'field',
    mixins: [emitter],
    data() {
      return {
      };
    },
    props: {
      label: [String, Number], //标题
      span: Number
    },
    computed: {
      colspan() {
        let cols = this.$parent.$parent.cols;
        return this.span ? this.span : 24/cols;
      },
      labelStyle() {
        let width = this.$parent.$parent.labelWidth;
        return {
          width: width,
          display: this.label ? 'block' : 'none'
        };
      },
      inputStyle() {
        let width = this.$parent.$parent.labelWidth;
        return {
          'margin-left': this.label ? width : '0px'
        };
      }
    },
    methods: {
      
    },
    created() {
    },
    mounted() {
      this.dispatch('block', 'el.block.addField', this);
    },
    beforeDestroy() {
      this.dispatch('block','el.block.removeField', this);
    }
  };
</script>



// WEBPACK FOOTER //
// field.vue?25cd6c48